<script setup>
import BasePage from "~/components/templates/BasePage.vue";
import PluginsPage from "~/components/templates/PluginsPage.vue";
import Plugin from "~/components/organisms/Plugin.vue";
import {useRoute} from "vue-router";
import AdminButton from "~/components/molecules/AdminButton.vue";
import Shortcode from "~/components/molecules/Shortcode.vue";
import {useUserStore} from "~/store/userStore";

const props = defineProps({
  data: Object
})

useHead({
  script: [
    {
      type: 'application/ld+json',
      children: props.data.breadcrumbs_structured_data
    },
  ],
})

const userStore = useUserStore();

const route = useRoute();

const {data} = props

</script>

<template>
  <PluginsPage>
    <template v-slot:ordinary-content>
      <BasePage v-if="data" :breadcrumbs="data.breadcrumbs">
        <template v-slot:preH1 v-if="data?.parent">
          <NuxtLink :to="'/'+data.parent.slug" class="image-and-title">
            <img src="/svg/arrow-left.svg" alt="arrow-left"/>
          </NuxtLink>
        </template>

        <template v-slot:title>
          {{ data.h1 }}
          <template v-if="route.query.page > 1">- {{ $t('pagination.page') }} {{ route.query.page }}</template>
        </template>

        <template v-if="data.subheading" v-slot:subheading>
          {{ data.subheading }}
        </template>
      </BasePage>

    </template>
    <template v-slot:[position] v-for="[position, plugins] of Object.entries(data.grouped_plugins)">
      <template v-for="plugin in plugins">
        <Plugin v-if="Array.isArray(plugin.data) ? plugin.data.length : Object.values(plugin.data).length"
                :key="plugin.name" :settings="plugin.settings"
                :data="plugin.data" :name="plugin.name"/>
      </template>
    </template>
  </PluginsPage>

  <Shortcode
      v-if="userStore.isAdmin"
      :shortcodes="{
        url: data?.admin?.shortcode_url ?? '',
        name: data?.admin?.shortcode_name ?? ''
    }"
      :bottom="150"
  />


  <AdminButton v-if="userStore.isAdmin">
    <slot name="admin"/>
  </AdminButton>
</template>
